import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useOnclickOutside from 'react-cool-onclickoutside';
import useTheme from '../theme';
import dt from '../../../../shared/theme';
import ListenOptionLink from './listen-dropdown-menu-components/listen-option-link';

const Button = styled.button`
  padding: 0 79px 0 65px;
  color: black;
  background-color: #FFF;
  line-height: 100%;

  ${props => props.theme.isROIXLarge && `
    padding: 0 73px 0 71px;
  `};

  ${props => props.theme.isROIMobile && `
    padding: 0;
  `};

  &:hover {
    background-color: #F0F3F6;
  }

  > span.listen-on-text {
    padding-right: 10px;
  }

  > span.icon-lw-chevron-down {
    font-size: 6px;
    font-weight: ${props => dt(props).theme.fontWeightBlack};
    transition: transform 0.5s cubic-bezier(0.4,0,0.2,1);

    &.flipped {
    transform: rotate(180deg);
    }
  }
`;

const DropdownMenu = styled.ul`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 2;
  margin: 5px 0 0;
  padding: 16px 16px 24px;
  transform: scale(0.95);
  visibility: hidden;
  background-color: white;
  border: 1px solid #D7DFE7;
  border-radius: 6px;
  box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: all 100ms cubic-bezier(0, 0, 0.2, 1);

  ${props => props.theme.isROIMobile && `
    position: static;
    height: 0;
    margin: 0;
    padding: 0;
    border: none;
  `};

  &.show {
    transform: scale(1);
    visibility: visible;

    ${props => props.theme.isROIMobile && `
      height: unset;
      margin: 5px 0 0;
      padding: 16px 16px 24px;
      border: 1px solid #D7DFE7;
    `};
  }

  > a:hover {
    text-decoration: none;
  }
`;

export default function ListenDropdown({ seriesId }) {
  const listenOnClicked = () => {
    document.querySelector('span.icon-lw-chevron-down').classList.toggle('flipped');
    document.querySelector('div.dropdown-container ul').classList.toggle('show');
  };

  const ref = useOnclickOutside(() => {
    document.querySelector('span.icon-lw-chevron-down').classList.remove('flipped');
    document.querySelector('div.dropdown-container ul').classList.remove('show');
  });

  return (
    <div className="dropdown-container" ref={ref}>
      <Button theme={useTheme()} onClick={listenOnClicked}>
        <span className="listen-on-text">Listen on</span>
        <span className="icon-lw icon-lw-chevron-down" />
      </Button>
      <DropdownMenu theme={useTheme()}>
        <ListenOptionLink name="Apple Podcasts" url="https://podcasts.apple.com/au/podcast/the-rules-of-investing/id1305615859" seriesId={seriesId} position={1} />
        <ListenOptionLink name="Spotify" url="https://open.spotify.com/show/4yjyRDXp7joZ7UbkVWxXPk" seriesId={seriesId} position={2} />
        <ListenOptionLink name="Podbean" url="https://livewiremarkets.podbean.com/" seriesId={seriesId} position={3} />
        <ListenOptionLink name="Amazon Music" url="https://music.amazon.com/podcasts" seriesId={seriesId} position={4} />
      </DropdownMenu>
    </div>
  );
}

ListenDropdown.propTypes = {
  seriesId: PropTypes.number.isRequired,
};
